module.exports = __webpack_public_path__ + "img/29.fae59af6.jpg";